import React, { Component } from 'react';
import './ProgressCircle.scss';

class ProgressCircle extends Component {
  state = { leftRotate: 0, rightRotate: 0 };
  fill = true;

  UNSAFE_componentWillMount() {
    this.fill = this.props.fill !== undefined ? this.props.fill : this.fill;

    if (this.fill) {
      this.setState({ leftRotate: 180, rightRotate: 180 });
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { value } = nextProps;
    let leftRotate = 0;
    let rightRotate = 0;

    if (this.fill) {
      leftRotate = value >= 50 ? 180 - (180 / 50 * (value - 50) ) : 180;
      rightRotate = value < 50 ? 180 - (180 / 50 * value) : 0;
    } else {
      leftRotate = value >= 50 ? (180 / 50 * (value - 50) * -1 ) : 0;
      rightRotate = value < 50 ? (180 / 50 * value * -1) : -180;
    }

    this.setState({ leftRotate, rightRotate });
  }

  render() {
    const { center, value, visible } = this.props;
    let { leftRotate, rightRotate } = this.state;

    return (
      <div className="progress-circle-outer" style={{ opacity: visible ? 1 : 0 }}>
        <div className="progress-left-half-outer">
          <div className="progress-left-half-rotate" style={{ transform: `rotateZ(${leftRotate}deg)`,
            transition: value > 0 && value < 98 ? 'transform 0.2s' : '' }}>
            <div className="progress-left-half-inner">
              <div className="progress-left-half-circle">
              </div>
            </div>
          </div>
        </div>
        <div className="progress-right-half-outer">
          <div className="progress-right-half-rotate" style={{ transform: `rotateZ(${rightRotate}deg)`,
            transition: value > 0 && value < 98 ? 'transform 0.2s' : '' }}>
            <div className="progress-right-half-inner">
              <div className="progress-right-half-circle">
              </div>
            </div>
          </div>
        </div>
        {center ? <div className="progress-circle-inner" style={{ backgroundColor: center }}></div> : null}
      </div>
    );
  }
}

export default ProgressCircle;



// WEBPACK FOOTER //
// ./src/components/ProgressCircle.js